<template>
  <v-btn elevation="10" depressed color="primary">
    <slot>Default Button</slot>
  </v-btn>
</template>

<script>
export default {
  name: "basicbtn",
  mixins: [],
  created() {},
  data: () => ({}),
  components: {},
  props: {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style></style>
